import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { authService } from '../services/authService'

const pageStyles: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#f8fafc',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
}

const containerStyles: React.CSSProperties = {
  width: '100%',
  maxWidth: '400px',
}

const cardStyles: React.CSSProperties = {
  backgroundColor: 'white',
  borderRadius: '0.75rem',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  padding: '2rem',
}

const headerStyles: React.CSSProperties = {
  textAlign: 'center',
  marginBottom: '2rem',
}

const titleStyles: React.CSSProperties = {
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '#111827',
  marginBottom: '0.5rem',
}

const subtitleStyles: React.CSSProperties = {
  fontSize: '0.9375rem',
  color: '#6b7280',
}

const formStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}

const inputGroupStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}

const labelStyles: React.CSSProperties = {
  fontSize: '0.875rem',
  fontWeight: '500',
  color: '#374151',
}

const inputStyles: React.CSSProperties = {
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid #d1d5db',
  fontSize: '1rem',
}

const buttonStyles: React.CSSProperties = {
  backgroundColor: '#2563eb',
  color: 'white',
  padding: '0.75rem 1rem',
  borderRadius: '0.5rem',
  border: 'none',
  fontSize: '1rem',
  fontWeight: '500',
  cursor: 'pointer',
}

const errorStyles: React.CSSProperties = {
  color: '#dc2626',
  fontSize: '0.875rem',
}

const successStyles: React.CSSProperties = {
  color: '#065f46',
  backgroundColor: '#ecfdf5',
  border: '1px solid #a7f3d0',
  borderRadius: '0.5rem',
  padding: '0.75rem',
  fontSize: '0.875rem',
  lineHeight: 1.6,
}

const linkStyles: React.CSSProperties = {
  textAlign: 'center',
  marginTop: '1rem',
  fontSize: '0.875rem',
  color: '#6b7280',
}

const linkAnchorStyles: React.CSSProperties = {
  color: '#2563eb',
  textDecoration: 'none',
  fontWeight: '500',
}

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')
    setMessage('')

    try {
      const result = await authService.requestPasswordReset(email)
      setMessage(result.message)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'リクエストに失敗しました')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div style={pageStyles}>
      <div style={containerStyles}>
        <div style={cardStyles}>
          <div style={headerStyles}>
            <h1 style={titleStyles}>パスワードをお忘れですか？</h1>
            <p style={subtitleStyles}>
              登録済みのメールアドレスに、再設定用のリンクを送信します。
            </p>
          </div>

          {message ? (
            <div style={successStyles} role="status">
              {message}
            </div>
          ) : (
            <form style={formStyles} onSubmit={handleSubmit}>
              <div style={inputGroupStyles}>
                <label htmlFor="email" style={labelStyles}>
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={inputStyles}
                  placeholder="you@example.com"
                  autoComplete="username"
                  inputMode="email"
                  required
                />
              </div>

              {error && (
                <div role="alert" aria-live="assertive" style={errorStyles}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                style={{ ...buttonStyles, ...(isLoading ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
              >
                {isLoading ? '送信中...' : '再設定リンクを送信'}
              </button>
            </form>
          )}

          <div style={linkStyles}>
            <Link to="/login" style={linkAnchorStyles}>
              ログインに戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
